import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import {
  Box,
  Button,
  Divider,
  FormControl,
  Paper,
  TextField,
  Typography,
  InputAdornment
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { DebounceInput } from 'react-debounce-input';
import { useNavigate } from 'react-router-dom';

import { useMutation } from 'react-fetching-library';
import { resetPasswordAction } from '../../services/request';

import { AlertDialogContainer } from '../others/AlertDialogContainer';

export const RestorePasswordPage = () => {
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [alertTitle, setAlertTitle] = React.useState('');
  const [alertMessage, setAlertMessage] = React.useState('');

  const { mutate } = useMutation(resetPasswordAction);

  const validationSchema = Yup.object({ email: Yup.string().email('Proszę podać poprawny adres e-mail')
    .required('To pole nie może być puste') });

  const initialValues = {
    email: ''
  };

  const [sent, setSent] = React.useState(false);

  const handleSubmit = async values => {
    const { error, payload } = await mutate(values);
    if (!error) {
      setSent(true);
      setSeverity('info');
      setAlertTitle('Wysłano e-mail');
      setAlertMessage('Na podany adres e-mail został wysłany link do zmiany hasła');
    } else {
      console.log(payload);
      setSeverity('error');
      setAlertTitle('Błąd');
      setAlertMessage(payload?.email?.message);
    }
    setShowAlert(true);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      component={Paper}
      elevation={5}
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto'
      }}
      padding={8}
    >
      <form onSubmit = {formik.handleSubmit}>
        {showAlert && (
          <AlertDialogContainer
            severity={severity}
            title={alertTitle}
            message={alertMessage}
            setShowAlert={setShowAlert}
          />
        )}
        <Box>
          <Typography color="primary" variant="h5" align="center">
          Przywracanie hasła
          </Typography>
        </Box>
        <Divider style={{ width: 450, marginTop: 20 }} />

        <FormControl
          style={{
            marginTop: 50,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography color="primary" variant="h6">
          Adres e-mail
          </Typography>
          <DebounceInput
            debounceTimeout={100}
            element={TextField}
            // error={errors.includes('email') ? true : false}
            error = {formik.touched.email && Boolean(formik.errors.email) }
            helperText = {formik.touched.email && formik.errors.email }
            variant="outlined"
            style={{ marginRight: 10, marginBottom: 10, width: 400 }}
            type="text"
            autoFocus
            name="email"
            value={formik.values.email}
            disabled={sent}
            onChange = {formik.handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              )
            }}

          />
        </FormControl>
        <Divider style={{ width: 450, marginTop: 50, marginBottom: 20 }} />
        <Button
          type = "submit"
          color="primary"
          variant="contained"
          style={{ marginBottom: 20 }}
          disabled={sent}
        >
        Zatwierdź
        </Button>
        <Box display="flex" flexDirection="row" justifyContent="center">
          <Button onClick={() => navigate('/login')}>
          Panel logowania
          </Button>
        </Box>
      </form>
    </Box>
  );
};
